import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { StudySettingVariable } from '../study-setting-variable.model';
import { DataTypeEnum } from '../../../../shared/ontology/data-type.enum';
import { BreedingMethodFilterTypeEnum, BreedingMethodsSelectComponent } from '../../../../shared/breeding-methods-select/breeding-methods-select.component';
import { NgSelectComponent } from '@ng-select/ng-select';
import { ValueReference } from '../../../../shared/model/observation-variable.model';
import { BreedingMethod } from '../../../../shared/breeding-method/model/breeding-method';
import { StudyInlineEditorComponent } from '../../../shared/study-inline-editor/study-inline-editor.component';
import { CREATE_STUDIES_PERMISSIONS } from '../../../../shared/auth/permissions';
import { NgbDateAdapter, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { CustomStringDateAdapter } from '../../../shared/adapters/custom-string-date-adapter';
import { CustomDateParserFormatter } from '../../../shared/adapters/custom-date-parser-formatter';

interface DropdownValue {
    id: string;
    name: string;
    description: string;
}

@Component({
    selector: 'jhi-study-settings-inline-editor',
    templateUrl: './study-settings-inline-editor.component.html',
    styleUrls: ['./study-settings-inline-editor.component.scss'],
    providers: [
        { provide: NgbDateAdapter, useClass: CustomStringDateAdapter },
        { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter }
    ]
})
export class StudySettingsInlineEditorComponent extends StudyInlineEditorComponent<any> {

    BREEDING_METHOD_ID = 8257;
    BREEDING_METHOD_CODE = 8251;

    readonly BreedingMethodFilterTypeEnum = BreedingMethodFilterTypeEnum;
    readonly DataTypeIdEnum = DataTypeEnum;
    categoricalItems: DropdownValue[] = [];

    @Input() studySettingVariable: StudySettingVariable;
    @ViewChild('inputElement') inputElement: ElementRef;
    @ViewChild('inputElement', { read: NgSelectComponent }) ngSelect: NgSelectComponent;
    @ViewChild(BreedingMethodsSelectComponent) breedingMethodsSelect: BreedingMethodsSelectComponent;

    @Output() onBlur = new EventEmitter<void>();
    @Output() onKeyDown = new EventEmitter<KeyboardEvent>();
    @Output() selectedBreedingMethod = new EventEmitter<BreedingMethod>();

    constructor(protected elementRef: ElementRef) {
        super(elementRef);
    }

    ngOnInit(): void {
        this.categoricalItems = this.convertToOptionDataItems(this.studySettingVariable.possibleValues);
    }

    ngAfterViewInit() {
        setTimeout(() => {
            if (this.studySettingVariable.dataTypeCode === 'C') {
                this.ngSelect?.focus();
                if (this.breedingMethodsSelect) {
                    this.breedingMethodsSelect.focus();
                }
            } else {
                this.inputElement?.nativeElement?.focus();
            }
        });
    }

    isBreedingMethod() {
        return this.studySettingVariable.termId === this.BREEDING_METHOD_ID || this.studySettingVariable.termId === this.BREEDING_METHOD_CODE;
    }

    convertToOptionDataItems(possibleValues: ValueReference[]): DropdownValue[] {
        if (possibleValues) {
            return possibleValues.map(possibleValue => ({
                id: possibleValue.id.toString(),
                name: possibleValue.name,
                description: possibleValue.description
            }));
        }
        return [];
    }

    handleBlur() {
        this.onBlur.emit();
    }

    handleKeyDown($event: KeyboardEvent) {
        this.onKeyDown.emit($event);
    }

    // If the rendered component is a breeding method select, manually set the
    // studySettingVariable.value with the breeding method code.
    onMethodChanged(breedingMethod: BreedingMethod) {
        this.studySettingVariable.value = breedingMethod.code;
        this.selectedBreedingMethod.emit(breedingMethod);
    }

    protected readonly CREATE_STUDIES_PERMISSIONS = CREATE_STUDIES_PERMISSIONS;
}
